module.exports = {
  "id": "b9c2a668-0639-4199-a14f-7f8959d2e8a4",
  "gtmIds": [
    "GTM-5XH8J9M9",
    "GTM-TF7LDBP"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "Pitztaler Gletscher & Rifflsee",
  "language": "de-DE",
  "defaultDateFormat": {
    "id": 1,
    "format": "DD/MM/YYYY",
    "name": "Numeric Day First (23/04/2026)"
  },
  "defaultNumberFormat": {
    "id": 3,
    "name": "European (Dot thousands, Comma decimals)",
    "format": "#.###,##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US",
    "de-DE"
  ],
  "website": "https://shop.pitztaler-gletscher.at",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}